export enum CarrierModule {
    Clearance = 'Clearance',
    Triage = 'Triage',
}
